import { boolean, object } from "yup";

export const moderatorFormSchema = object().shape({
    adminPanelAccess: boolean().required("required"),
    categoryModeration: boolean().required("required"),
    feedbackModeration: boolean().required("required"),
    promotionAccess: boolean().required("required"),
});
